//资源
const state = {
  breadCrumbMap: {
    1: '最新动态',
    2: '通知公告',
    3: '教育资讯',
    4: '媒体报道',
  },
};

const mutations = {};

export default {
  state,
  mutations
};